import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC, useMemo } from 'react';

import { Opponent } from '@gem/call/CallStore/Opponent/Opponent';
import { useCallContext } from '@gem/call/CallView/CallView.context';
import { ActiveSpeakerIcon } from '@gem/call/components/ActiveSpeakerIcon/ActiveSpeakerIcon';
import { IcRaisedHand16Icon, IcMicOff16Icon, IcShareScreen16Icon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IconView, IconViewSizes } from '@gem/ui-kit';

import styles from './OpponentMeta.styles.m.css';

interface IOpponentMetaProps {
  opponent: Opponent | null;
  isMinimize?: boolean;
  isRightList?: boolean;
}

export const OpponentMeta: FC<IOpponentMetaProps> = observer(
  ({ opponent, isMinimize, isRightList }) => {
    const { t } = useTranslation();
    const { call } = useCallContext();

    // TODO: выпилить и переделать на инишиал MeMember
    const displayName = useMemo(() => {
      if (!opponent?.memberDevice?.member && opponent?.isMe && call.initialMeOpponentAvatar) {
        return call.initialMeOpponentAvatar.title;
      }

      return opponent?.memberDevice?.member.displayName;
    }, [opponent?.memberDevice?.member]);

    if (!opponent) {
      return null;
    }

    return (
      <>
        <div className={classNames(styles.meta, { [styles.minimize]: isMinimize && !isRightList })}>
          <div className={styles.metaGroup}>
            {opponent.memberDevice?.hasScreenSharingOpponent && !opponent.isSharedScreen && (
              <IconView
                Icon={IcShareScreen16Icon}
                className={styles.sharingIcon}
                size={IconViewSizes.Small}
              />
            )}
            <div className={styles.name}>
              {opponent.isSharedScreen ? t('calls_screensharing', { 0: displayName }) : displayName}
            </div>
            {!opponent.isSharedScreen &&
              (!opponent.hasAudio ? (
                <IconView
                  Icon={IcMicOff16Icon}
                  size={IconViewSizes.Small}
                  className={styles.muted}
                />
              ) : (
                <ActiveSpeakerIcon
                  isBig
                  isSilence={!opponent.isActiveSpeaker}
                />
              ))}
          </div>

          {opponent.memberDevice?.isHandRaised && !opponent.isSharedScreen && (
            <div
              className={classNames(styles.handRaisedContainer, {
                [styles.handRaisedContainerWithNumber]: !!opponent.handRaisedPosition,
              })}
            >
              <IconView
                Icon={IcRaisedHand16Icon}
                size={IconViewSizes.Small}
                className={classNames(styles.handRaised, {
                  [styles.handRaisedWithNumber]: !!opponent.handRaisedPosition,
                })}
              />
              {!!opponent.handRaisedPosition && (
                <span className={classNames(styles.handRaisedNumber)}>
                  {opponent.handRaisedPosition}
                </span>
              )}
            </div>
          )}
        </div>
      </>
    );
  }
);
